import { getAllGames } from "../games";
import { GettonciniMenuIcon } from "../icons";

// Generate game menu items dynamically from GAME_CONFIG
const gameMenuItems = getAllGames()
  .filter(game => !game.hidden)
  .map(game => ({
    label: game.displayName,
    icon: game.menuIcon,
    href: `/${game.pathName}`,
    badge: game.is_new ? 'Nuovo!' : undefined
  }));

// Menu items for the drawer navigation
// Note: User profile section is rendered separately at top of drawer
export const menuItems = [
  {
    type: 'section',
    label: 'Giochini',
    items: gameMenuItems
  },
  {
    type: 'divider'
  },
  {
    type: 'section',
    label: 'In Contatto',
    items: [
      { label: 'Registrati', icon: 'fas fa-user-plus', href: '/registrati' },
      { label: 'Newsletter', icon: 'fas fa-envelope', href: '/newsletter' },
      { label: 'Installa', icon: 'fas fa-download', href: '/install' },
    ]
  },
  {
    type: 'divider'
  },
  {
    type: 'section',
    label: 'Traguardi',
    items: [
      { label: 'Gettoncini', icon: GettonciniMenuIcon, href: '/gettoncini' },
      { label: 'Serie', icon: 'fas fa-fire', href: '/serie' },
      { label: 'Stelline', icon: 'fas fa-star', href: '/stelline' },
      { label: 'Assistente AI', icon: 'fas fa-wand-magic-sparkles', href: '/assistente-ai' },
    ]
  },
  {
    type: 'divider'
  },
  {
    type: 'section',
    label: 'Informazioni',
    items: [
      { label: 'Chi siamo', icon: 'fas fa-info-circle', href: '/chi-siamo' },
      { label: 'Contatti', icon: 'fas fa-paper-plane', href: '/contatti' },
      { label: 'Collaborazioni', icon: 'fas fa-handshake', href: '/collaborazioni' },
      { label: 'Insegnanti', icon: 'fas fa-chalkboard-teacher', href: '/insegnanti' },
    ]
  },
  {
    type: 'divider'
  },
  {
    type: 'section',
    label: 'Legale',
    items: [
      { label: 'Termini di servizio', icon: 'fas fa-file-contract', href: '/terms' },
      { label: 'Privacy policy', icon: 'fas fa-shield-alt', href: '/privacy' },
    ]
  },
];
